import i18n from 'i18next'

import en from './en.json'
import fr from './fr.json'

// Merge studio's auth strings into the shared core i18next instance
// (deep merge so core keys are preserved). Must be imported after
// '@livingdata/playground-core-front/i18n'.
i18n.addResourceBundle('en', 'translation', en, true)
i18n.addResourceBundle('fr', 'translation', fr, true)
